module.exports = __webpack_public_path__ + "img/folder.96434fe0.svg";